<template>
  <b-card id="page-whitelist" no-body class="mb-0 p-2">
    <b-card-header class="pl-0 pr-0">
      <b-card-title>
        <h2>{{ $t(label("title")) }}</h2>
      </b-card-title>

      <b-col v-if="canCreate" cols="12" md="8" class="d-none d-md-table">
        <b-col cols="12" class="d-flex align-items-between justify-content-end">
          <b-button id="tooltip-create" variant="primary" @click="onCreate">
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span class="text-nowrap">{{ $t(label("register")) }}</span>
          </b-button>
        </b-col>
      </b-col>

      <b-col
        v-if="canCreate"
        cols="12"
        sm="12"
        md="8"
        class="d-md-none d-flex justify-content-end align-items-center pt-2"
      >
        <b-button
          id="tooltip-create"
          variant="primary"
          @click="onCreate"
          class="btn-icon"
        >
          <feather-icon icon="PlusIcon" size="18" />
        </b-button>
      </b-col>

      <b-tooltip
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>
    <Filterss
      :fields="fildsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />
    <!-- Table for larger devices -->
    <!-- class="d-none d-md-table" -->
    <b-table
      id="whitelist-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table"
    >
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(nameContac)="data">
        <slot name="cell-nameContac" :data="data">
          {{ data.item.nameContac || "N/A" }}
        </slot>
      </template>
      <template #cell(phoneNumber)="data">
        <slot name="cell-phoneNumber" :data="data">
          {{ data.item.phoneNumber || "N/A" }}
        </slot>
      </template>
      <template #cell(actions)="data">
        <feather-icon
          v-if="canShow"
          class="text-success mr-25"
          size="18"
          icon="FileTextIcon"
          @click="onShow(data.item.idWhiteList)"
        />

        <feather-icon
          v-if="canEdit"
          class="text-primary mr-25"
          size="18"
          icon="EditIcon"
          @click="onEdit(data.item.idWhiteList)"
        />

        <feather-icon
          v-if="canDelete"
          class="text-danger"
          size="18"
          icon="Trash2Icon"
          @click="onDelete(data.item.idWhiteList)"
        />
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>

    <!-- Pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>

    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.guid"
          class="d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <strong> {{ item.nameContact }}</strong>

            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item v-if="canShow" @click="onShow(item.idWhiteList)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-success mr-25"
                    size="18"
                    icon="FileTextIcon"
                  />
                  {{ $t("show") }}
                </div>
              </b-dropdown-item>
              <b-dropdown-item v-if="canEdit" @click="onEdit(item.idWhiteList)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-primary mr-25"
                    size="18"
                    icon="EditIcon"
                  />
                  {{ $t("edit") }}
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canDelete"
                @click="onDelete(item.idWhiteList)"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-danger"
                    size="18"
                    icon="Trash2Icon"
                  />
                  {{ $t("delete") }}
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <!-- <br /> -->
          {{ item.phoneNumber ? item.phoneNumber : "N/A" }}
          <br />
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading" class="text-center">
          <b-spinner variant="success"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BAvatar,
  BFormGroup,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

import {
  allWhitheListByCompany,
  deleteWhitheList,
} from "@/@core/api/request/whitelist";
import Filterss from "../components/filters/Filterss.vue";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormGroup,
    BTooltip,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    Filterss,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    model: "whitelist",
    companyGuid: null,
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    fields: [
      { label: "name", key: "nameContact", sortable: true },
      { label: "phone", key: "phoneNumber", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        type: "text",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
    appliedFilters: {},
    name: null,
    filtersOn: false,
    hasNextPage: true,
    name: null,
    category: null,
  }),
  computed: {
    canCreate() {
      return canAccess("White List", "creation");
    },
    canShow() {
      return canAccess("White List", "reading");
    },
    canEdit() {
      return canAccess("White List", "edition");
    },
    canDelete() {
      return canAccess("White List", "elimination");
    },
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.loadData(guid);
    },
  },
  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadData();
  },

  async mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    label(field) {
      return `pages.whitelist.table.${field}`;
    },

    labelHeader(field) {
      return `pages.whitelist.table.tableHeader.${field}`;
    },

    async loadData() {
      try {
        this.loading = true;
        const params = this.chargeParams();

        // Usamos Promise.all para cargar productos y catálogos en paralelo
        const [containersResp] = await Promise.all([
          allWhitheListByCompany(params),
        ]);

        // Procesamos productos
        const containers = _.get(containersResp, "data");
        console.log("data->", containers);
        this.items = containers?.items || [];
        this.totalRows = containers?.totalRows || 0;
        this.hasNextPage =
          containers?.currentPage < containers?.totalPages || 0;
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },
    loadDataWithFIlters(name) {
      // if (!this.hasNextPage) return;
      const param = this.chargeParamsWhitFilters(name);
      this.loading = !this.loading;
      allWhitheListByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data", []);
          if (Array.isArray(data?.items)) {
            // Agregar nuevos elementos sin sobreescribir los existentes
            this.items = data.items;
            this.items = [...this.items];
          }
          this.totalRows = data?.totalRows || 0;
          // Verificar si hay más páginas
          this.hasNextPage = data?.currentPage < data?.totalPages || false;
          this.loading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    async loadDataInfinity() {
      try {
        this.loading = true;
        const params = this.chargeParams();
        allWhitheListByCompany(params)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              // Agregar nuevos elementos sin sobreescribir los existentes
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            // Verificar si hay más páginas
            this.hasNextPage = data?.currentPage < data?.totalPages || false;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.error("Error loading products infinitely", error);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error cargando productos infinitamente", error.message);
      }
    },
    chargeParams() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      arrParams.push(`guidCompany,${this.companyGuid}`);
      arrParams.push(`active,${true}`);

      return getParams(arrParams);
    },

    chargeParamsWhitFilters(name) {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      arrParams.push(`active,${true}`);
      if (name != null) arrParams.push(`name,${name}`);
      return getParams(arrParams);
    },

    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadDataInfinity();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },

    handlePerPageChange() {
      // Reset currentPage to 1 when changing perPage
      this.currentPage = 1;
      this.loadData();
    },
    onCreate() {
      if (!this.canCreate) return;
      this.$router.push({
        name: "whitelistCreate",
        params: {
          option: 1, // option 1 to create
        },
      });
    },
    onShow(idWhiteList) {
      if (!this.canShow) return;
      this.$router.push({
        name: "whitelistEdit",
        params: {
          option: 2, // option 2 to show
          idWhiteList,
        },
      });
    },

    onEdit(idWhiteList) {
      if (!this.canEdit) return;
      this.$router.push({
        name: "whitelistEdit",
        params: {
          option: 3, // option 3 to edit
          idWhiteList,
        },
      });
    },

    onInfo() {},

    onDelete(idWhiteList) {
      if (!this.canDelete) return;
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteWhitheList(idWhiteList)
            .then((resp) => {
              stopLoading();

              const status = _.get(resp, "status");
              if (status == 500) {
                this.message(
                  this.$t("Alert"),
                  this.$t("registerHasntDeleted"),
                  "error",
                );
                return;
              }
              this.message(
                this.$t("Deleted"),
                this.$t("beenDeleted"),
                "success",
              );
              this.loadData();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", `Alerta codigo`, error.message);
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },
    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
    applyFilters(filters) {
      this.appliedFilters = filters;
      this.name = filters.name;
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadDataWithFIlters(filters.name == null ? null : filters.name);
    },
    resetFilters() {
      this.appliedFilters = {};
      this.name = null;
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
